import { Chip, cn } from '@ds';
import { isNil } from 'lodash-es';
import { getYesNoChipClassName } from './utils';
import { yesNo } from '@/utils/helpers';

export const YesNoChip = ({ value, className }: { value?: boolean; className?: string }) => {
  if (isNil(value)) return null;

  return (
    <Chip className={className ?? cn('text-s-m text-center p-0 h-5 min-w-9.25', getYesNoChipClassName(value))}>
      {yesNo(value)}
    </Chip>
  );
};
